import { useEffect, useState } from 'react';

interface BrowserLocalRecordingPlaybackProps {
  blob: Blob | null;
  label: string;
  description?: string;
  className?: string;
}

const BrowserLocalRecordingPlayback: React.FC<BrowserLocalRecordingPlaybackProps> = ({
  blob,
  label,
  description = 'Herstelde opname beluisteren',
  className = 'mb-6 bg-gray-50 border border-gray-200 rounded-lg p-4',
}) => {
  const [audioUrl, setAudioUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setAudioUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(blob);
    setAudioUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [blob]);

  if (!blob || !audioUrl) {
    return null;
  }

  return (
    <div className={className}>
      <p className="text-sm font-medium text-gray-700 mb-2">{description}</p>
      {/* No controlsList: this audio was recorded on this machine and has not
          been sent anywhere, so the player's own menu may offer to save it.
          The retained server-side recording still sets nodownload. */}
      <audio
        aria-label={`${label} afspelen`}
        controls
        preload="metadata"
        src={audioUrl}
        className="w-full"
      />
    </div>
  );
};

export default BrowserLocalRecordingPlayback;
